export const scWalletMatcha = [
	{
		anonymous: false,
		inputs: [
			{ indexed: true, internalType: 'address', name: 'from', type: 'address' },
			{ indexed: true, internalType: 'address', name: 'to', type: 'address' },
			{ indexed: false, internalType: 'uint256', name: 'amt', type: 'uint256' },
			{ indexed: false, internalType: 'uint256', name: 'minReceived', type: 'uint256' },
			{ indexed: false, internalType: 'bytes', name: 'data', type: 'bytes' },
			{ indexed: false, internalType: 'uint256', name: 'setId', type: 'uint256' }
		],
		name: 'LogSwap',
		type: 'event'
	},
	{
		inputs: [],
		name: 'name',
		outputs: [{ internalType: 'string', name: '', type: 'string' }],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [
			{ internalType: 'address', name: 'from', type: 'address' },
			{ internalType: 'address', name: 'to', type: 'address' },
			{ internalType: 'uint256', name: 'amt', type: 'uint256' },
			{ internalType: 'uint256', name: 'minReceived', type: 'uint256' },
			{ internalType: 'bytes', name: 'data', type: 'bytes' },
			{ internalType: 'uint256', name: 'setId', type: 'uint256' }
		],
		name: 'swap',
		outputs: [
			{ internalType: 'string', name: '_eventName', type: 'string' },
			{ internalType: 'bytes', name: '_eventParam', type: 'bytes' }
		],
		stateMutability: 'payable',
		type: 'function'
	}
];
